export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9993.e9038fff.jpg";